export const reportError = (error) => {
  if (typeof window !== 'undefined') {
    newrelic.noticeError(error);
  }
};
